import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import Layout from "../components/Layout";

export default function Home() {

  const NextArrow = ({ onClick }) => (
    <div className="custom-arrow next-arrow" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="23"
        viewBox="0 0 32 23"
        fill="none"
      >
        <path
          d="M31.1788 10.2328C31.7506 10.8323 31.7282 11.7818 31.1288 12.3536L21.3607 21.672C20.7612 22.2439 19.8118 22.2215 19.2399 21.6221C18.6681 21.0226 18.6905 20.0732 19.2899 19.5013L27.9727 11.2183L19.6896 2.53548C19.1178 1.93606 19.1401 0.986576 19.7396 0.414749C20.339 -0.157078 21.2885 -0.134708 21.8603 0.464713L31.1788 10.2328ZM0.0351562 10.5601L0.0704864 9.06047L30.1287 9.76865L30.0934 11.2682L30.0581 12.7678L-0.000173899 12.0596L0.0351562 10.5601Z"
          fill="black"
        />
      </svg>
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev-arrow" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="23"
        viewBox="0 0 32 23"
        fill="none"
        style={{ transform: "rotate(180deg)" }}
      >
        <path
          d="M31.1788 10.2328C31.7506 10.8323 31.7282 11.7818 31.1288 12.3536L21.3607 21.672C20.7612 22.2439 19.8118 22.2215 19.2399 21.6221C18.6681 21.0226 18.6905 20.0732 19.2899 19.5013L27.9727 11.2183L19.6896 2.53548C19.1178 1.93606 19.1401 0.986576 19.7396 0.414749C20.339 -0.157078 21.2885 -0.134708 21.8603 0.464713L31.1788 10.2328ZM0.0351562 10.5601L0.0704864 9.06047L30.1287 9.76865L30.0934 11.2682L30.0581 12.7678L-0.000173899 12.0596L0.0351562 10.5601Z"
          fill="black"
        />
      </svg>
    </div>
  );

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const reviewslide = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const [index, setIndex] = useState(3); // middle image starts selected

  const total = 8; // total number of images

  const getClass = (i) => {
    const diff = (i - index + total) % total;
    switch (diff) {
      case 0:
        return "selected";
      case 1:
        return "next";
      case 2:
        return "nextRightSecond";
      case total - 1:
        return "prev";
      case total - 2:
        return "prevLeftSecond";
      default:
        return diff > 2 ? "hideRight" : "hideLeft";
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1
    ,
    slidesToScroll: 1,
    arrows: false,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 576,
        settings: {
          centerMode: false,
          centerPadding: "0px",
        },
      },
    ],
  };




  return (
    <Layout>
      <section className="main-banner">
        <Container>
          <div>
            <div className="slider-container howitworks-section">
              <Slider {...settings}>
                <div>
                  <div className="banner-slide-card">
                    <div>
                      <h1>1. Scan your QR Code</h1>
                      <p>
                        Scan your purchased Pixels and Hearts Memory Medallion™
                        to register your Online Profile
                      </p>
                      <button>Try Now</button>
                    </div>
                    <div>
                      <img
                        src={require("../assets/images/banner-mobile.png")}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="banner-slide-card">
                    <div>
                      <h1>1. Scan your QR Code</h1>
                      <p>
                        Scan your purchased Pixels and Hearts Memory Medallion™
                        to register your Online Profile
                      </p>
                      <button>Try Now</button>
                    </div>
                    <div>
                      <img
                        src={require("../assets/images/banner-mobile.png")}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="banner-slide-card">
                    <div>
                      <h1>1. Scan your QR Code</h1>
                      <p>
                        Scan your purchased Pixels and Hearts Memory Medallion™
                        to register your Online Profile
                      </p>
                      <button>Try Now</button>
                    </div>
                    <div>
                      <img
                        src={require("../assets/images/banner-mobile.png")}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="banner-slide-card">
                    <div>
                      <h1>1. Scan your QR Code</h1>
                      <p>
                        Scan your purchased Pixels and Hearts Memory Medallion™
                        to register your Online Profile
                      </p>
                      <button>Try Now</button>
                    </div>
                    <div>
                      <img
                        src={require("../assets/images/banner-mobile.png")}
                      />
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </Container>
      </section>

      <section className="p-80">
        <Container>
          <div className="who-we-are-sec">
            <h2>Who We Are?</h2>
            <p>
              Summer Rose is a digital memorial platform that blends QR/NFC
              technology, AI, and AR to let families celebrate and remember
              loved ones through interactive, private, and beautifully designed
              online memorials.
            </p>
            <p className="m-0">
              When someone scans a physical QR/NFC tag placed on a headstone,
              urn, or keepsake, they’re taken to that person’s unique memorial
              page — a seamless, elegant web experience that feels timeless and
              emotionally immersive.
            </p>
          </div>
        </Container>
      </section>

      <section className="how-it-works-sec p-80">
        <Container>
          <div className="how-works-content">
            <h2>How It Works</h2>
            <p>Three simple steps to honor your loved ones</p>

            <div className="how-works-cards">
              <div>
                <img
                  src={require("../assets/images/how-works-one.svg").default}
                />
                <h3>Scan QR/NFC</h3>
                <p>
                  Simply scan the QR code or tap the NFC tag to
                  <br /> access the memorial
                </p>
              </div>
              <div>
                <img
                  src={require("../assets/images/how-works-two.svg").default}
                />
                <h3>View Memorial</h3>
                <p>
                  Explore photos, stories, and cherished memories in
                  <br /> a beautiful digital space
                </p>
              </div>
              <div>
                <img
                  src={require("../assets/images/how-works-three.svg").default}
                />
                <h3>Share Tributes or Gifts</h3>
                <p>
                  Leave tributes, share memories, or send digital
                  <br /> AR gifts
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="see-a-memorial p-80">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-md-0">
              <div className="memorial-text">
                <h2>See a Memorial in Action</h2>
                <p>
                  Explore our demo memorial to see how beautiful and meaningful
                  a digital tribute can be. Every memorial is fully customizable
                  with photos, stories, and interactive features.
                </p>
                <button>View Demo</button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="memorial-img">
                <img src={require("../assets/images/sarahjohnson.png")} />
                <div className="">
                  <h4>Sarah Johnson</h4>
                  <p>1945 — 2023</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="features-that-matter  p-80">
        <Container>
          <div className="features-data">
            <h2>Features That Matter</h2>
            <p>Everything you need to create a meaningful tribute</p>
            <Row>
              <Col lg={4} className="mb-4 mb-md-0">
                <div className="feature-card">
                  <img
                    src={require("../assets/images/features-one.svg").default}
                  />
                  <h3>AI Family Photos</h3>
                  <p>
                    Transform old photos with AI enhancement and colorization to
                    bring memories to life
                  </p>
                </div>
              </Col>
              <Col lg={4} className="mb-4 mb-md-0">
                <div className="feature-card">
                  <img
                    src={require("../assets/images/features-two.svg").default}
                  />
                  <h3>AR Digital Gifts</h3>
                  <p>
                    Send beautiful augmented reality gifts like flowers,
                    candles, and butterflies
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="feature-card">
                  <img
                    src={require("../assets/images/features-three.svg").default}
                  />
                  <h3>Private Memorials</h3>
                  <p>
                    Control who can view and contribute to your loved one's
                    memorial space
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section className="see-a-memorial p-80">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-md-0">
              <div className="memorial-text">
                <h2>Live the moments in pictures again with AR!</h2>
                <p>
                  AR & AI, these are not just technologies, they are induced in
                  our product! You can convert you images into videos just like
                  these moments are video captured. Click the demo button an
                  just enjoy!
                </p>
                <button>Create</button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="memorial-img">
                <img src={require("../assets/images/moments-pictures.png")} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="living-tribute p-80">
        <Container>
          <div className="living-tribute-data">
            <h2>A Living Tribute to Every Life</h2>
            <p>
              Create, share, and preserve memories that grow more meaningful
              with every visit.
            </p>
            <div className="living-tribute-cards">
              <div className="living-tribute-item">
                <img
                  src={
                    require("../assets/images/living-tribute-one.svg").default
                  }
                />
                <h3>One Tap, a Lifetime of Memories</h3>
                <p>
                  Scan a personalized QR tag to open a timeless digital space —
                  filled with photos, tributes, and love.
                </p>
                <Link to="">
                  Learn more
                  <img
                    src={require("../assets/images/right-arrow.svg").default}
                  />
                </Link>
              </div>
              <div className="living-tribute-item">
                <img
                  src={
                    require("../assets/images/living-tribute-two.svg").default
                  }
                />
                <h3>One Tap, a Lifetime of Memories</h3>
                <p>
                  Scan a personalized QR tag to open a timeless digital space —
                  filled with photos, tributes, and love.
                </p>
                <Link to="">
                  Learn more
                  <img
                    src={require("../assets/images/right-arrow.svg").default}
                  />
                </Link>
              </div>
              <div className="living-tribute-item">
                <img
                  src={
                    require("../assets/images/living-tribute-three.svg").default
                  }
                />
                <h3>One Tap, a Lifetime of Memories</h3>
                <p>
                  Scan a personalized QR tag to open a timeless digital space —
                  filled with photos, tributes, and love.
                </p>
                <Link to="">
                  Learn more
                  <img
                    src={require("../assets/images/right-arrow.svg").default}
                  />
                </Link>
              </div>
              <div className="living-tribute-item">
                <img
                  src={
                    require("../assets/images/living-tribute-four.svg").default
                  }
                />
                <h3>One Tap, a Lifetime of Memories</h3>
                <p>
                  Scan a personalized QR tag to open a timeless digital space —
                  filled with photos, tributes, and love.
                </p>
                <Link to="">
                  Learn more
                  <img
                    src={require("../assets/images/right-arrow.svg").default}
                  />
                </Link>
              </div>
            </div>
            <div className="living-tribute-action">
              <button>Create a Memorial</button>
            </div>
          </div>
        </Container>
      </section>

      <section className="p-80">
        <Container>
          <div className="living-tribute-data">
            <h2>Moments That Speak Forever</h2>
            <p>
              Every image and tribute tells a story — of laughter, love, and the
              lives that touched ours.
            </p>

            <div className="carousel-container">
              <Swiper
                effect={"coverflow"}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={3}
                loop={true}
                spaceBetween={-50}
                coverflowEffect={{
                  rotate: 0,
                  stretch: 0,
                  depth: 150,
                  modifier: 2,
                  slideShadows: true,
                }}
                breakpoints={{
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: -50,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: -30,
                  },
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                  },
                }}
                pagination={{ clickable: true }}
                modules={[EffectCoverflow, Pagination]}
                className="mySwiper"
              >
                {/* Static images (no array needed) */}
                <SwiperSlide>
                  <img
                    src={require("../assets/images/sarahjohnson.png")}
                    alt="Slide 1"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={require("../assets/images/sarahjohnson.png")}
                    alt="Slide 2"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={require("../assets/images/sarahjohnson.png")}
                    alt="Slide 3"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={require("../assets/images/sarahjohnson.png")}
                    alt="Slide 4"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={require("../assets/images/sarahjohnson.png")}
                    alt="Slide 5"
                  />
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </Container>
      </section>

      <section className="p-80">
        <Container>
          <div className="living-tribute-data">
            <h2>What Our Client Says</h2>

            <div className="review-slide">
              <Slider {...reviewslide}>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </Container>
      </section>

      {/* <section className="choose-your-plan-sec p-80">
        <Container>
          <div className="choose-your-content">
            <h2>Choose Your Plan</h2>
            <p>Select the perfect plan for honoring your loved ones</p>

            <div className="your-plan-cards">
              <div className="plan-card-item">
                <div>
                  <h2>Free</h2>
                  <h3>
                    $0<span>/year</span>
                  </h3>
                  <p>Perfect for getting started</p>
                  <ul>
                    <li>Basic memorial page</li>
                    <li>Up to 10 photos</li>
                    <li>Text tributes</li>
                    <li>QR code access</li>
                  </ul>
                </div>
                <button>Choose Plan</button>
              </div>
              <div className="plan-card-item active">
                <span>Most Popular</span>
                <h2>Premium</h2>
                <h3>
                  $29<span>/year</span>
                </h3>
                <p>Most popular for families</p>
                <ul>
                  <li>Unlimited photos & videos</li>
                  <li>AR digital gifts</li>
                  <li>AI photo enhancement</li>
                  <li>Custom domain</li>
                  <li>Priority support</li>
                </ul>
                <button>Choose Plan</button>
              </div>
              <div className="plan-card-item">
                <h2>Family+</h2>
                <h3>
                  $79<span>/year</span>
                </h3>
                <p>For extended families</p>
                <ul>
                  <li>Everything in Premium</li>
                  <li>Up to 5 memorials</li>
                  <li>Family tree integration</li>
                  <li>Advanced privacy controls</li>
                  <li>Dedicated support</li>
                </ul>
                <button>Choose Plan</button>
              </div>
            </div>
          </div>
        </Container>
      </section> */}
    </Layout>
  );
}
